<div class="empty-state">
  <div class="empty-state__wrapper">
    <div class="empty-state__wrapper__content">
      <img src="/assets/img/empty-state-tachograph.svg" alt="">

      <div class="empty-state__wrapper__content__text">
        <span class="title">{{'noDataInThisTime' | translate}}</span>
        <span class="desc">{{'emptyStateDescriptionTachograph' | translate}}</span>
      </div>
    </div>
  </div>
</div>
